<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="popupConfig.hideOnOutsideClick"
    :show-close-button="false"
    :show-title="true"
    :width="width"
    :height="height"
    :title="'Update Batch Details for ' + model.ProductCode"
    :wrapper-attr="wrapperAttr"
    ref="gc-popup"
    @shown="onShown"
    @initialized="onInitialized"
  >
    <DxToolbarItem
      v-if="popupConfig.formMode !== 'create' && popupConfig.secondaryTitle"
      location="before"
      :html="`<span class='toolbar-title-secondary text-secondary'> ${popupConfig.secondaryTitle}</span>`"
    ></DxToolbarItem>
    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
    />

    <div class="css-v2 gc-popup-form" v-if="popupConfig.isPopupShow">
      <gc-form
        :key="popupConfig.formKey"
        :form-options="{
          gcLabelLocation: 'left',
        }"
        ref="gc-header-form"
        :form-items="getHeaderFormItems"
        :is-normal="true"
        :data-model="model"
        :form-mode="popupConfig.formMode"
        :from-from="'gc-header-form-d-a'"
        :form-height="popupConfig.height - 85"
        v-if="IsFormLoaded"
      />
    </div>

    <div class="footer modal-popup-footer-action-container">
      <DxButton
        text="SAVE"
        type="default"
        styling-mode="contained"
        class="save-btn-cl dx-button dx-button-mode-contained dx-button-default dx-button-has-text"
        @click="onSavePopupHandler"
        :ref="'footer-save-btn'"
      />
      <!-- :disabled="!model.NewLocation || !model.NewLocationRecordId" -->
      <DxButton
        text="Cancel"
        type="default"
        styling-mode="contained"
        class="dx-button dx-button-mode-contained dx-button-normal dx-button-has-text"
        @click="onCancelPopupHandler"
      />
    </div>
  </DxPopup>
</template>
<script>
import { mapGetters } from "vuex";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { ProductBatchService } from "../../_services/api/inventory/product-batch.service";

export default {
  mixins: [DataGridMixin],
  components: {},
  data() {
    return {
      popupAuditVisible: false,
      model: {
        BatchNo: null,
        ProductCode: null,
        SupplierCode: null,
        ManufacturedDate: null,
        ExpiryDate: null,
        ExpiryMethod: null,
        SupplierDescription: null,
        SupplierBatchNo: null,
      },
      IsFormLoaded: false,
      slPopupConfig: {
        visible: false,
        dataModel: {},
      },

      ignoreLocationChangeEvent: false,
    };
  },
  props: {
    popupConfig: {
      type: Object,
      default: () => {},
    },
    onToolbarMenuItemOnClick: {
      type: Function,
      default: () => {},
    },
    wrapperAttr: {
      type: Object,
      default: () => {},
    },
    onHide: {
      type: Function,
      default: () => [],
    },
    width: {
      type: Number,
      default: 300,
    },
    height: {
      type: Number,
      default: 600,
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    applicationFeatureCode: {
      type: String,
      default: "ProductBatchManagement",
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    saveCallBack: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
  },
  async created() {
    this.showLoading(true);

    const batchDetails = this.dataModel;

    this.model.BatchNo = batchDetails.Batch;
    this.model.ProductCode = batchDetails.ProductCode;
    this.model.SupplierCode = batchDetails.SupplierCode;
    this.model.SupplierDescription = batchDetails.SupplierDescription;
    this.model.ManufacturedDate = batchDetails.ManufacturedDate;
    this.model.ExpiryMethod = batchDetails.ExpiryMethod;
    this.model.ExpiryDate = batchDetails.ExpiryDate;
    this.model.SupplierBatchNo = batchDetails.SupplierBatchNo;

    this.IsFormLoaded = true;
  },
  methods: {
    setStorageLocationLineModel() {
      this.slPopupConfig.visible = true;
    },

    releasePopupHide() {
      this.releasePopupInfo.isPopupShow = false;
    },

    /**
     * Handle Audit Popup
     */
    onAuditPopupHandler() {
      this.popupAuditVisible = !this.popupAuditVisible;
    },

    /**
     * on popup model shown
     */
    onShown() {
      // if (this.dataModel) {
      //   this.FriendlyStatus = this.dataModel.FriendlyStatus;
      // }
      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
    },

    /**
     * on pop up model hide
     */
    onPopupHide() {
      this.onHide();
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
    },

    onInitialized(e) {
      if (this.popupConfig.formMode !== "review")
        e.component.registerKeyHandler("escape", (arg) => {
          arg.stopPropagation();
        });
    },

    onEditPopupHandler() {
      this.popupConfig.formMode = "edit";
      this.popupConfig.hideOnOutsideClick = false;
      this.popupConfig.formKey++;
    },

    /**
     * On Save Popup Handler
     */
    async onSavePopupHandler() {
      {
        const payload = {
          BatchNo: this.model.BatchNo,
          ProductCode: this.model.ProductCode,
          SupplierCode: this.model.SupplierCode,
          ManufacturedDate: this.model.ManufacturedDate,
          ExpiryDate: this.model.ExpiryDate,
          ExpiryMethod: this.model.ExpiryMethod,
          SupplierBatchNo: this.model.SupplierBatchNo,
        };

        try {
          this.showLoading(true);
          const result = await ProductBatchService.updateBatchData(payload);
          this.$notify(
            `Batch ${result.data.BatchNo} for ${payload.ProductCode} Product has been updated.`,
            "success"
          );
          this.model = {
            BatchNo: null,
            ProductCode: null,
            SupplierCode: null,
            ManufacturedDate: null,
            ExpiryDate: null,
            ExpiryMethod: null,
          };

          this.$nextTick(() => {
            this.showLoading(false);
            this.saveCallBack();
          });
        } catch (e) {
          this.saveAsDraft = false;
          this.showLoading(false);
          this.displayServerError(e, "Save Failed");
        }
      }
    },

    /**
     * on Cancel Popup Handler
     */
    async onCancelPopupHandler() {
      if (this.popupConfig.isPopupShow) {
        const confirm = await this.$confirm(
          `You have unsaved changes. Are you sure you want to leave?`,
          "Unsaved changes",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
          }
        );
        if (confirm) {
          this.showLoading(false);
          this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
          if (this.popupConfig.formMode === "create") {
            this.popupConfig.isPopupShow = false;
          } else {
            this.popupConfig.hideOnOutsideClick = true;
            this.popupConfig.formMode = "review";
            this.popupConfig.formKey++;
            this.popupConfig.isPopupShow = false;

            // await this.resetEditedData();
          }
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    async ManufacturedDateChanged(e) {
      //   if (e.value) {
      //     this.updateFormValues("ExpiryDate", e.value);
      //   }
    },
    // eslint-disable-next-line no-unused-vars
    async ExpiryDateChanged(e) {
      //   if (e.value) {
      //     this.updateFormValues("ManufacturedDate", e.value);
      //   }
    },
    async resetEditedData() {
      this.model.ManufacturedDate = null;
      this.model.ExpiryDate = null;
      this.model.BatchNo = null;
      this.model.ProductCode = null;
      this.model.SupplierCode = null;
      this.model.ExpiryMethod = null;
    },

    /**
     * on so list grid toolbar preparing
     * @param e - event
     */
    onToolbarPreparing(e) {
      e.toolbarOptions.visible = false;
    },

    updateFormValues(dataField, value) {
      const form = this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;
      form.beginUpdate();
      form.updateData(dataField, value);
      form.endUpdate();
    },
  },
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    vueInstance() {
      return this;
    },
    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "Batch",
                  dataField: "BatchNo",
                  label: {
                    text: "Batch #",
                  },
                  required: true,
                  editorOptions: {
                    rtlEnabled: false,
                    elementAttr: {
                      class: "bin-card-field",
                    },
                  },
                },

                // {
                //   screenField: "Product",
                //   required: true,
                //   displayExpr: (item) => {
                //     if (item) return item.Code + " - " + item.Description1;
                //     else return "";
                //   },
                // },
                {
                  // screenField: "Supplier",
                  dataField: "SupplierDescription",
                  label: {
                    text: "Supplier",
                  },
                  required: true,
                },
                {
                  screenField: "SupplierBatchNo",
                  label: {
                    text: "Supplier Batch #",
                  },
                  editorOptions: {
                    allowUpdate: true,
                    maxLength: 20,
                  },
                },
                {
                  screenField: "ManufacturedDate",
                  label: {
                    text: "Manufactured Date",
                  },
                  ref: "ManufacturedDateRef",
                  editorOptions: {
                    ref: "ManufacturedDateRef",
                    allowUpdate: true,
                    readOnly: false,
                    onFocusIn: (e) => {
                      if (this.model.ManufacturedDate) {
                        e.event.target.select();
                      }
                    },
                    max: this.model.ExpiryDate,
                    onValueChanged: this.ManufacturedDateChanged.bind(this),
                  },
                  dataField: "ManufacturedDate",
                  editorType: "dxTextBox",
                },
                {
                  dataField: "ExpiryMethod",
                  label: {
                    text: "Expiry Method",
                  },
                  required: true,
                },
                {
                  screenField: "ManufacturedDate",
                  label: {
                    text: "Expiry Date",
                  },
                  ref: "ExpiryDateRef",
                  editorOptions: {
                    ref: "ExpiryDateRef",
                    allowUpdate: true,
                    readOnly: false,
                    onFocusIn: (e) => {
                      if (this.model.ExpiryDate) {
                        e.event.target.select();
                      }
                    },
                    min: this.model.ManufacturedDate,
                    onValueChanged: this.ExpiryDateChanged.bind(this),
                  },
                  dataField: "ExpiryDate",
                  editorType: "dxTextBox",
                },
              ],
            },
          ],
        },
      ];
    },

    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode !== "review",
          options: {
            icon: "close",
            onClick: this.onCancelPopupHandler,
            visible: this.popupConfig.formMode !== "review",
          },
        },
      ];
    },
  },
  watch: {
    getHotKeySave: {
      handler(val) {
        if (val) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          if (this.popupConfig.formMode !== "review") this.onSavePopupHandler();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.gc-popup-update-batch {
  .status-template {
    display: flex;
    align-items: center;
  }
  .dx-toolbar.dx-popup-title {
    height: 60px;
  }

  .toolbar-title-secondary {
    padding-left: unset !important;
    font-weight: 400;
    font-size: 14px;
  }

  .modal-popup-footer-action-container {
    padding-top: 10px;
    bottom: 0;
    margin-right: 0px;
    height: 45px;
    text-align: right;
    display: flex;
    justify-content: center;

    .save-btn-cl {
      margin-right: 10px;
      width: 120px;
    }

    .cancel-btn-cl {
      margin-right: 10px;
      width: 120px;
    }
  }

  .bin-card-field {
    input {
      text-align: left;
    }
  }
}
</style>
